export { default } from "./useDeletePoll";
